<template>
  <div class="rating-container">
    <span
      @click="$emit('onSetvalue', item)"
      :key="item"
      v-for="item in parseInt(this.max)"
      :class="getClass(item)"
    ></span>
  </div>
</template>

<script>
export default {
  emits: ['onSetvalue'],
  props: {
    size: String,
    max: [String, Number],
    value: [String, Number],
    selectable: Boolean,
  },
  methods: {
    getClass(item) {
      return `fa fa-star ${this.size} ${
        Number(this.value) >= item
          ? "checked" + (this.selectable ? " select" : "")
          : this.selectable
          ? " select"
          : ""
      }`;
    },
  },
};
</script>

<style scoped lang="scss">
.rating-container {
  display: inline-block;
  
  span {
    &.select {
      cursor: pointer;
    }
  }
}
</style>
